import React, { ReactNode } from 'react'

interface IListProps {
  children: ReactNode
}

const AutocompleteList: React.FC<IListProps> = ({ children }) => {
  return (
    <ul id="autocomplete" className="npf-autocomplete__list">
      {children}
    </ul>
  )
}
export default AutocompleteList
